import { CruisesContract, definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

const resource = 'bookings';

type BookingStepsByBookingId = definitions['BOOKING_STEPS_BY_BOOKING_ID'];
type FetchBookingsParams = definitions['BOOKING_LIST_QUERY_PARAMS'];
export type BookingList = definitions['BOOKING_LIST'];
export type BookingById = definitions['BOOKING_BY_ID'];
export type ConsolidatedPaymentSchedule = definitions['GET_CONSOLIDATED_PAYMENT_SCHEDULE'];

export type BookingByIdResponse = CruisesContract.Response<BookingById>;
export type BookingStepsByBookingIdResponse = CruisesContract.Response<BookingStepsByBookingId>;
export type BookingListResponse = CruisesContract.Response<BookingList>;
export type ConsolidatedPaymentScheduleResponse = CruisesContract.Response<ConsolidatedPaymentSchedule>;

export type Booking = BookingList[0];

const getById = async (id: string): Promise<BookingByIdResponse> => {
  let status: number;

  try {
    const res: BookingByIdResponse = await cruisesAPI.http.get({
      resource: `${resource}/${id}`,
    });

    status = res.status;
    if (res.result && !res.errors) return res;
  } catch (err) {
    console.error('[Cruise Booking - Get By Id]: ', err);
    return { status: status, message: err, result: null };
  }
};

const getBatchBookingsById = async (ids: string[]): Promise<BookingListResponse> => {
  let status: number;

  const params = {
    resource,
    queryString: JSON.stringify({
      bookingIds: ids,
      take: ids.length,
      skip: 0,
    }),
  };

  try {
    const res: BookingListResponse = await cruisesAPI.http.get(params);

    status = res.status;
    if (res.result && !res.errors) return res;
  } catch (err) {
    console.error('[Cruise Booking - Get Batch By Id]: ', err);
    return { status: status, message: err, result: null };
  }
};

const getBookingStepsByBookingId = async (bookingId: string): Promise<BookingStepsByBookingIdResponse> => {
  try {
    const res: BookingStepsByBookingIdResponse = await cruisesAPI.http.get({
      resource: `${resource}/${bookingId}/steps`,
    });

    if (!res.errors && res.result) {
      return res;
    }
  } catch (err) {
    console.error('[Cruise Booking - Get Booking Steps By Id]: ', err);
    return { status: err.status, message: err.message, result: null };
  }
};

const getBookings = async (params: FetchBookingsParams): Promise<BookingListResponse> => {
  try {
    const res: BookingListResponse = await cruisesAPI.http.get({
      resource,
      queryString: JSON.stringify(params),
    });

    if (!res.errors && res.result) {
      return res;
    }
  } catch (err) {
    console.error('[Cruise Bookings - Booking List]: ', err);
    return { status: err.status, message: err.message, result: null };
  }
};

export default {
  getById,
  getBatchBookingsById,
  getBookingStepsByBookingId,
  getBookings,
};
